export const extractDataFromForm = (formEvent) => {
  if (!formEvent) return null

  const formData = new FormData(formEvent.target)
  const data = {}

  formData.forEach((value, key) => {
    if (key !== 'g-recaptcha-response') {
      data[key] = value
    }
  })

  return data
}

export const extractDataFromFormData = (formData) => {
  const data = {}
  formData.forEach((value, key) => (data[key] = value))
  return data
}
